import React, { createContext } from 'react';
import PropTypes from 'prop-types';

const { shape, arrayOf, element, oneOfType } = PropTypes;

export const QuickViewContext = createContext();

export const QuickViewProvider = ({
  value,
  children
}) => <QuickViewContext.Provider value={value}>{children}</QuickViewContext.Provider>;

QuickViewProvider.propTypes = {
  value: shape({}).isRequired,
  children: oneOfType([
    arrayOf(element),
    element
  ]).isRequired
};
